import { Phone, CheckCircle2 } from 'lucide-react';

export const QuoteSuccess = ({ onReset }) => (
  <div className="min-h-[70vh] flex items-center justify-center bg-zinc-50">
    <div className="text-center max-w-md mx-auto px-4">
      <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
        <CheckCircle2 className="w-10 h-10 text-green-600" />
      </div>
      <h1 className="text-3xl font-black text-zinc-900 mb-4">Quote Request Received!</h1>
      <p className="text-zinc-600 mb-8">
        Thank you for your interest. Our team will review your request and get back to you within 24 hours.
      </p>
      <div className="flex flex-col gap-4">
        <a 
          href="tel:+18776809272"
          className="inline-flex items-center justify-center gap-2 bg-red-600 hover:bg-red-700 text-white px-8 py-4 font-bold uppercase tracking-wide transition-colors"
        >
          <Phone className="w-4 h-4" />
          Call Us Now
        </a>
        <button
          onClick={onReset}
          className="text-zinc-600 hover:text-zinc-900 font-medium"
        >
          Submit Another Request
        </button>
      </div>
    </div>
  </div>
);
